import { HomepageLayout } from '#/components/layout/HomepageLayout';
import { Skeleton, SkeletonRegion } from '#/components/ui/Skeleton';

/**
 * Full-page skeleton shown while the homepage loader fetches initial content
 * from the API. Prevents a blank screen during Lambda cold starts.
 */
export function HomepageSkeleton() {
  return (
    <SkeletonRegion label="Loading Market Data and Investments Explorer">
      {/* Navigation placeholder */}
      <div className="col-full px-20 py-16">
        <Skeleton className="h-48 w-full rounded-lg" />
      </div>

      {/* Hero area placeholder */}
      <div className="col-full px-20 py-24">
        <Skeleton className="h-[200px] w-full rounded-lg" />
      </div>

      <HomepageLayout className="flow flow-inner-60 mt-80">
        {/* Explore concepts section */}
        <section className="col-feature">
          <Skeleton className="mb-16 h-24 w-1/3" />
          <div className="grid grid-cols-2 gap-16 sm:grid-cols-4">
            <Skeleton className="h-[120px] rounded-lg" />
            <Skeleton className="h-[120px] rounded-lg" />
            <Skeleton className="h-[120px] rounded-lg" />
            <Skeleton className="h-[120px] rounded-lg" />
          </div>
        </section>

        {/* News section */}
        <section className="col-feature">
          <Skeleton className="mb-16 h-24 w-1/4" />
          <div className="grid gap-16 sm:grid-cols-3">
            <Skeleton className="h-[180px] rounded-lg" />
            <Skeleton className="h-[180px] rounded-lg" />
            <Skeleton className="h-[180px] rounded-lg" />
          </div>
        </section>

        {/* Tables section */}
        <section className="col-feature grid min-w-0 gap-20 lg:grid-cols-2">
          <div>
            <Skeleton className="mb-12 h-20 w-2/3" />
            <Skeleton className="h-[200px] rounded-lg" />
          </div>
          <div>
            <Skeleton className="mb-12 h-20 w-2/3" />
            <Skeleton className="h-[200px] rounded-lg" />
          </div>
        </section>
      </HomepageLayout>
    </SkeletonRegion>
  );
}
